import type { ApiUsageTranslations } from '../interfaces/apiUsage';

export const apiUsageTranslations: ApiUsageTranslations = {
  page_title: 'API Usage',
  page_description: 'Calls made with API keys, broken down by resource and period.',

  window_7d: '7 days',
  window_30d: '30 days',
  window_90d: '90 days',

  granularity_label: 'Group by',
  granularity_hour: 'Hour',
  granularity_day: 'Day',
  granularity_week: 'Week',
  granularity_month: 'Month',

  filter_all_resources: 'All resources',
  filter_all_keys: 'All API keys',
  filter_resource_aria: 'Filter by resource',
  filter_key_aria: 'Filter by API key',

  kpi_total_calls: 'Total calls',
  kpi_total_calls_sub: 'current window',
  kpi_errors: 'Errors',
  kpi_error_rate: 'Error rate',
  kpi_error_rate_sub: 'responses ≥ 400',
  kpi_avg_latency: 'Avg latency',
  kpi_p95_latency: 'p95 latency',
  kpi_latency_sub: 'response time',

  chart_title: 'Calls over time',
  chart_sub: 'Total calls per period',
  chart_legend_calls: 'Calls',
  chart_legend_errors: 'Errors',
  chart_empty: 'No calls in the selected window.',

  table_title: 'Breakdown by resource and API key',
  table_sub: 'Sorted by number of calls',
  col_resource: 'Resource',
  col_api_key: 'API key',
  col_calls: 'Calls',
  col_errors: 'Errors',
  col_error_rate: 'Error rate',
  col_avg_latency: 'Avg (ms)',
  col_p95_latency: 'p95 (ms)',

  unknown_key: 'Unknown',

  empty_title: 'No usage data',
  empty_description: 'No API-key calls have been recorded in this period yet.',
  error_title: 'Could not load API usage',
  retry: 'Retry',
};
